import { useController } from '../hooks/useController'

import { Alert, AlertTitle, Stack } from '@mui/material'

export function Body() {
  const {
    data: { title, subtitle },
  } = useController()

  return (
    <Stack direction="column" width="100%" height="100%" flexShrink={0} marginTop={4}>
      <Alert severity="warning">
        <AlertTitle>{title}</AlertTitle>
        {subtitle}
      </Alert>
    </Stack>
  )
}
